// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDxIYg-TZ-h-qnJ9n6pD7RxBW5mf_Io5fQ",
  authDomain: "e-crypto-7427d.firebaseapp.com",
  projectId: "e-crypto-7427d",
  storageBucket: "e-crypto-7427d.firebasestorage.app",
  messagingSenderId: "472577449630",
  appId: "1:472577449630:web:82177ee362f9e4854a258f",
  measurementId: "G-SPR5NXGFLY"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app)
export const db = getFirestore(app);
